import './style/index.css';
import './lib/i18n/i18n';
import { StrictMode } from 'react';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import initConceptReplyDeepLink from './features/compose/initConceptReplyDeepLink';

console.log({
  __APP_VERSION__,
  environment: import.meta.env.VITE_ENVIRONMENT,
});

const BUGSINK_DSN_BY_ENVIRONMENT: Record<string, string> = {
  STAGING:
    'https://079a615b0bb94995960657337bb0c57e@bugsink.hetzner.wegroup.be/52',
  PRODUCTION:
    'https://9d91ebf1d4f043e6822c1cd9a7862488@bugsink.hetzner.wegroup.be/51',
};

Sentry.init({
  dsn: BUGSINK_DSN_BY_ENVIRONMENT[import.meta.env.VITE_ENVIRONMENT],
  enabled: !import.meta.env.DEV,
  sendDefaultPii: true,
  environment: import.meta.env.VITE_ENVIRONMENT,
  release: __APP_VERSION__,
});

void initConceptReplyDeepLink();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
